<template>
  <Layout
    v-if="!appState$$.isOffline"
    v-show="!appState$$.inProgress && state$$.isVisible"
  >
    <template #body>
      <Autorization />
    </template>
  </Layout>
</template>

<script setup>
import {
  inject,
  onMounted,
  reactive,
  // computed,
  ref,
} from 'vue';

// #region STTEDRA
import {
  // useImmer,
  useDev,
  useNormalizer,
} from '@sttedra_ui/framework';
// #endregion

// #region COMPONENTS COMPOSABLES
import Autorization from '@/components/autorization/Autorization.vue';
import Layout from '@/components/layout/Layout.vue';
import useManageApiError from '@/composables/manage-api-error';
// #endregion

// #region MODELS AND STATE
import HomeViewState from './home.view-state';
// #endregion

// #region COMPONENTS COMPOSABLES
import {useRouter} from 'vue-router';
// import {useStore} from 'vuex';
// #endregion

// #region API
import {StatusCodes as HttpStatus} from 'http-status-codes';

import {checkTokenLapsed as checkTokenLapsedApi} from '@/api/auth/auth.api';

import {checkRegisterApplications as checkRegisterApplicationsApi}
  from '@/api/register/register.api';
// #endregion

// #region  Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');
const router = useRouter();
// const store = useStore();

const state = new HomeViewState();
const state$$ = reactive(state);

const typePortal = ref(STTEDRA_TYPE_PORTAL);
// const isTutorizeMode = computed(() => store.getters['register/isTutorizeMode']);

const {
  getObjectFilled,
} = useNormalizer();

const {
  showErrorToast,
} = useManageApiError();
// #endregion

// #region Functions
async function checkAuth() {
  try {
    // // MOCK;
    // // Identification: 05719171Z  MitmaCode: JV23-05719171Z-7H9S2
    // const registerApplications = {
    //   identification: '05719171Z',
    //   name: 'ADRIAN', // puede editar
    //   surname: 'QUESADA', // puede editar
    //   secondSurname: 'LOPEZ', // puede editar
    //   email: 'a@a.com', // puede editar
    //   phone: '123456789', // puede editar
    //   supportNumber: '', // puede editar
    //   registeredDate: '14/07/2021',
    //   applicationRegistrationCode: '123456789',
    //   consolidatedRegister: {
    //     mitmaCode: 'JV23-05719171Z-7H9S2',
    //     // mitmaCode: '',
    //     stateId: 1,
    //     // stateId: 3, // puede editar
    //     // stateId: 4, // // puede editar
    //     // stateId: 5,
    //     // stateId: 6,
    //     // stateDescription: 'Usuario registrado con bonificación', // VERDE
    //     // stateDescription: 'Pendiente de verificación', // VERDE
    //     // stateDescription: 'Usuario registrado sin bonificación', // ROJO
    //     // stateDescription: 'Datos del usuario incorrectos', // ROJO
    //     // stateDescription: 'Bloqueado por uso indebido', // ROJO
    //     // stateCode: '00',
    //     // stateCode: '02',
    //     // stateCode: '03',
    //     // stateCode: '04',
    //     // stateCode: '05',
    //     registeredDate: '2023-05-23T00:00:00',
    //     notificable: true,
    //   },
    // };

    // appState$$.detailRequest = registerApplications;

    // const dataRoute = {};
    // router.push({
    //   name: `DetailRequest`,
    //   ...dataRoute,
    // });

    // return;
    // //  END MOCK

    if (appState$$.errorInLogin) {
      showErrorToast('Error, hubo un problema en la pasarela de login clave. Intentelo de nuevo.');
      appState$$.defaultStateApp();
      return;
    }

    if (appState$$.isLogged) {
      appState$$.setLoginApp(true);
      const isTokenValid = await checkTokenValidate();
      if (!isTokenValid) {
        appState$$.defaultStateApp();
        return;
      }

      const hasRegister = await manageRegisterApplications();
      if (hasRegister) return;

      if (typePortal.value !== 'codigos' || appState$$.isTutorizeRegisterRedirect) {
        appState$$.setLoginApp(true);
        appState$$.isTutorizeRegisterRedirect = false;
        const dataRoute = {};
        router.push({
          name: appState$$.isTutorizeRegister ? 'RegisterTutorize' : 'Register',
          ...dataRoute,
        });
      }

      return;
    }
  } catch (t) {
    useDev.error('[Home] checkAuth', t);
  }
  appState$$.defaultStateApp();
}

async function manageRegisterApplications() {
  try {
    appState$$.setLoginApp(true);
    const registerApplications = await checkRegisterApplications();

    // MOCK
    // registerApplications = {
    //   identification: '123456789',
    //   name: 'Juan', // puede editar
    //   surname: 'Perez', // puede editar
    //   secondSurname: 'Perez', // puede editar
    //   email: 'a@a.com', // puede editar
    //   phone: '123456789', // puede editar
    //   supportNumber: 'XXXXX', // puede editar
    //   registeredDate: '14/07/2021',
    //   applicationRegistrationCode: '123456789',
    //   consolidatedRegister: {
    //     mitmaCode: 'JV23-12345678A-ABCD1',
    //     // mitmaCode: '',
    //     stateId: 1,
    //     // stateId: 2,
    //     // stateId: 3, // puede editar
    //     // stateId: 4, // // puede editar
    //     // stateId: 5,
    //     // stateId: 6,
    //     stateDescription: 'Usuario registrado con bonificación', // VERDE
    //     // stateDescription: 'Pendiente de verificación', // VERDE
    //     // stateDescription: 'Usuario registrado sin bonificación', // ROJO
    //     // stateDescription: 'Datos del usuario incorrectos', // ROJO
    //     // stateDescription: 'Bloqueado por uso indebido', // ROJO
    //     // stateCode: '00',
    //     // stateCode: '02',
    //     // stateCode: '03',
    //     // stateCode: '04',
    //     // stateCode: '05',
    //     registeredDate: '2023-05-31T18:09:43.74',
    //     notificable: true,
    //   },
    // };

    if (!getObjectFilled(registerApplications)) {
      appState$$.setLoginApp(false);
      appState$$.detailRequest = null;
      return false;
    }

    appState$$.detailRequest = {
      ...registerApplications,
      temporalToken: appState$$?.token,
    };
    appState$$.setLoginApp(false);

    // const dataRoute = {};
    // router.push({
    //   name: `DetailRequest`,
    //   ...dataRoute,
    // });

    return true;
  } catch (t) {
    useDev.error('[Home] manageRegisterApplications', t);
  }
  appState$$.detailRequest = null;
  appState$$.setLoginApp(false);
}

async function checkTokenValidate() {
  const response = await checkTokenLapsedApi(appState$$?.token);
  return response?.status !== HttpStatus.OK ? false : true;
}

async function checkRegisterApplications() {
  const {
    response,
    registerApplicationsModel,
  } = await checkRegisterApplicationsApi(appState$$?.token);

  if (response?.status === HttpStatus.OK && getObjectFilled(registerApplicationsModel)) {
    return registerApplicationsModel;
  }

  return false;
}
// #endregion

// #region Effects, Hooks
onMounted(async () => {
  state$$.isVisible = false;
  await checkAuth();
  state$$.isVisible = true;
});
// #endregion
</script>
